import { render, staticRenderFns } from "./GraficoDonutCadastrosDiarios.vue?vue&type=template&id=f489270c"
import script from "./GraficoDonutCadastrosDiarios.vue?vue&type=script&lang=ts"
export * from "./GraficoDonutCadastrosDiarios.vue?vue&type=script&lang=ts"
import style0 from "./GraficoDonutCadastrosDiarios.vue?vue&type=style&index=0&id=f489270c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports